import { useCallback, useMemo } from 'react';
import { BlockType, ComponentSettings, ComponentSettingsDataset, DisplayMask } from '@report-content';

export default function useFirstDatasetMasks(
    blocks: Array<BlockType<ComponentSettings>>,
    displayMasksList: Array<DisplayMask>,
) {
    const displayMasks = useMemo(() => {
        const firstDataset: ComponentSettingsDataset | undefined = blocks.find(
            (b) => b.component.internalName == 'dataset',
        )?.component.settings as ComponentSettingsDataset;
        if (!firstDataset) {
            return [];
        }
        return firstDataset.fields.map((f) => ({
            reference_name: f.reference_name,
            display_mask: f.display_mask_id,
        }));
    }, [blocks]);

    return useCallback(
        (defaultFormat: string, filterReferenceName: string) => {
            let dateFormat = defaultFormat;
            const dm = displayMasks.find((m) => m.reference_name == filterReferenceName);
            if (dm) {
                const mask = displayMasksList.find((m) => m.display_mask_id == dm.display_mask);
                if (mask) {
                    dateFormat = mask.data_format_string_js;
                }
            }
            return dateFormat;
        },
        [displayMasksList, displayMasks],
    );
}
